$(document).on('click', '.faq--item .h3', function () {
  $(this).toggleClass('is-active');
});
